import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { getApiData } from "../../../services/index";

const TestimonialSlider = () => {
  const [testimonials, setTestimonials] = useState([]);

  const checkData = () => {
    const app = {};
    getApiData("api/get_testimonials", app).then((result) => {
      let responseJson = result;
      if (responseJson && result["status"] === 200) {
        setTestimonials(result["data"]);
      }
    });
  };

  useEffect(() => {
    checkData();
  }, []);

  useEffect(() => {}, [testimonials]);

  return (
    <section className="section">
      <div className="container">
        <div className="max-w more mb-5">
          <div className="flex-tag">
            <div className="bullet-tag color"></div>
            <h2 className="main-title">Client Testimonials</h2>
          </div>
          <p className="subhead-main for-title black">
            Hear what our successful students have to say about{" "}
            <span className="gray-text-color">
              <strong className="bold-text-2">Win Migration Group.</strong>
            </span>
          </p>
        </div>
        <Swiper
          spaceBetween={15}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          modules={[Pagination, Autoplay]}
          loop={true}
        >
          {testimonials.map(
            (testimonial, index) =>
              testimonial.type === "image" && (
                <SwiperSlide key={index}>
                  <div className="testimonial-card">
                    <img
                      src={testimonial.media}
                      alt={testimonial.name}
                      className="rounded-lg w-full h-auto mb-4"
                    />
                    <h3 className="text-lg font-bold mb-2">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-600 line-clamp-6">
                      {testimonial.description}
                    </p>
                    <h3 className="">
                      <a
                        href={testimonial.url}
                        target="_blank"
                        className="text-[#81CFAC] hover:text-[#374151]"
                      >
                        View
                      </a>
                    </h3>
                  </div>
                </SwiperSlide>
              )
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSlider;
